// extracted by mini-css-extract-plugin
module.exports = {"main_content_container":"ProjectMasterPlanePage_main_content_container__z8Al7"};